import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import useClinic from 'hooks/useClinic';
import RevampServicePage from 'pages/RevampServicePage';
import ServicesPage from '..';

const WrapperServicePage = () => {
  const { data, isLoading } = useClinic();

  const isBlockSchedulingEnabled = data?.isBlockSchedulingEnabled;

  if (isLoading) {
    return (
      <div data-testid="page-service">
        <LoadingScreen />
      </div>
    );
  }

  if (isBlockSchedulingEnabled) {
    return (
      <div data-testid="page-service">
        <RevampServicePage />
      </div>
    );
  }

  return (
    <div data-testid="page-service">
      <ServicesPage />
    </div>
  );
};

export default WrapperServicePage;
